import { ToolbarSection, ToolbarItem } from "../../../editor";

export const PageSettings = () => {
  return (
    <>
      <ToolbarSection title="Page fields" defaultOpen={true}>
        <ToolbarItem full={true} propKey="title" label="Title" type="text" />
        <ToolbarItem
          full={true}
          propKey="description"
          label="Description"
          type="text"
        />
      </ToolbarSection>
    </>
  );
};
